import React from 'react';
import PropTypes from 'prop-types';
import './analytics-card.scss';

function AnalyticsCard({
    isLoading,
    title,
    content,
    footerPositiveValue,
    footerNegativeValue,
    footerValue,
    chipValue
}) {
    return (
        <div className='analytics-card'>
            <div className='analytics-card-root'>
                {!isLoading && <h6 className="analytics-card-title">{title}</h6>}
                <h3 className="analytics-card-content">
                    {isLoading ?
                        <div>{'Loading...'}</div> :
                        <div>{content}</div>}
                </h3>
                {!isLoading && <h6 className="analytics-card-footer">
                    <span className='positive'>{footerPositiveValue}</span>
                    <span className='negative'>{footerNegativeValue}</span>
                    {footerValue}
                </h6>}
                {!isLoading && chipValue && <div className="analytics-card-chip analytics-card-actions">
                    <span className="analytics-card-chip-label">{chipValue}</span>
                </div>}
            </div>
        </div>
    );
}

AnalyticsCard.propTypes = {
    isLoading: PropTypes.bool,
    title: PropTypes.string,
    content: PropTypes.string,
    footerPositiveValue: PropTypes.string,
    footerNegativeValue: PropTypes.string,
    footerValue: PropTypes.string,
    chipValue: PropTypes.string,
};

export default AnalyticsCard;
